<template>
  <button class="github-auth-button" @click="handleClick" type="button">
    <img :src="require('@/assets/svg/github.svg')" class="github-icon" alt="GitHub" />
    <span class="github-button-text">Continue with GitHub</span>
  </button>
</template>

<script>
export default {
  methods: {
    handleClick() {
      this.$trackEvent('login.github-login-button.click', {
        cta: 'github-button'
      });
      this.$emit('click');
    }
  }
};
</script>

<style lang="scss" scoped>
.github-auth-button {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  background: var(--transparent-white-5);
  border: 1px solid var(--transparent-white-5);
  border-radius: 8px;

  padding: 0 12px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(255, 255, 255, 0.1);
  }

  .github-icon {
    width: 18px;
    height: 18px;
    filter: invert(1);
  }

  .github-button-text {
    font-family: 'Mulish', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: var(--transparent-white-60);
  }
}
</style>
